/**
 * 상수
 */
export const DATAS = {
  ASA_APP_CODE: "cert_product",
};
